import { add as hasAdd } from '@dojo/framework/core/has';

const isMicro = /msurv1|mqual1/.test(window.location.pathname);
const isNext = /cic2|ltccip2|aipc2/.test(window.location.pathname);

hasAdd('dev-build', !/partnerrc|hclspstaging/.test(window.location.hostname));
// static flags
hasAdd('ati-use-single-rpc', true);
hasAdd('practice-exam', false);
hasAdd('use-alternate-next', true);
hasAdd('use-alternate-pass-view', false);
hasAdd('use-search-in-heading', true);
hasAdd('use-study-plan', false);
hasAdd('use-topicgroup-quiz', false);
hasAdd('use-topicgroup-reading', true);
hasAdd('use-xapi', true);

// dynamic flags
hasAdd('no-explore-assess', isMicro);
hasAdd('posttest', isMicro || isNext);
hasAdd('quiz-progress-chart', !isMicro);
hasAdd('use-alternate-header', isMicro);
hasAdd('use-alternate-footer', isMicro || isNext);
hasAdd('use-assessment-chooser', isNext);
hasAdd('use-audio-topics', isMicro || isNext);
hasAdd('use-cards-layout', isNext);
hasAdd('use-carousel-view', isNext);
hasAdd('use-cutscores', !isMicro && !isNext);
hasAdd('use-landing-page', isNext);
hasAdd('use-micro-view', isMicro);
hasAdd('use-posttest-forward-progression', isNext);
hasAdd('use-quiz-survey', isNext);
hasAdd('use-svg-header-image', isNext);
hasAdd('use-svg-card-header-images', isNext);
